import {MRT_ColumnDef} from 'material-react-table';

import {UserLink} from '@entities/user';
import {Transaction} from '../types';

const userColumn: MRT_ColumnDef<Transaction> = {
  accessorKey: 'userId',
  header: 'User',
  Cell: ({row}) => <UserLink userId={row.original.userId} />,
  size: 130,
};

/** Inserts the User column right after ID, without mutating the input array */
export const withUserColumn = (
  columns: MRT_ColumnDef<Transaction>[],
): MRT_ColumnDef<Transaction>[] => [
  columns[0]!,
  userColumn,
  ...columns.slice(1),
];
